import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Pages
import Home from 'src/components/Dashboard/Views/Pages/Home.vue'
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import PasswordForgot from 'src/components/Dashboard/Views/Pages/PasswordForgot.vue'
import PasswordReset from 'src/components/Dashboard/Views/Pages/PasswordReset.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'

import FileserviceOverview from 'src/components/Dashboard/Views/Pages/Fileservice/Overview.vue'
import TicketOverview from 'src/components/Dashboard/Views/Pages/Tickets/Overview.vue'
import CreditOverview from 'src/components/Dashboard/Views/Pages/Credits/Overview.vue'
import TransactionOverview from 'src/components/Dashboard/Views/Pages/Transactions/Overview.vue'
import TransactionVerify from 'src/components/Dashboard/Views/Pages/Transactions/Verify.vue'

// Charts
let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

let passwordForgotPage = {
  path: '/password-forgot',
  name: 'PasswordForgot',
  component: PasswordForgot
}

let passwordResetPage = {
  path: '/password-reset/:token',
  name: 'PasswordReset',
  component: PasswordReset
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

let logoutAction = {
  path: '/logout',
  name: 'Logout',
  props: {
    logout: true
  },
  component: Login
}

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/portal',
    name: 'Dashboard',
    component: DashboardLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home
      },
      {
        path: 'edit-profile',
        name: 'Edit Profile',
        component: User
      },
      {
        path: 'fileservice',
        name: 'Fileservice',
        component: FileserviceOverview
      },
      {
        path: 'tickets',
        name: 'Tickets',
        component: TicketOverview
      },
      {
        path: 'credits',
        name: 'Credits',
        component: CreditOverview
      },
      {
        path: 'transactions',
        name: 'Transactions',
        component: TransactionOverview
      },
      {
        path: 'transactions/verify/:transactioncode',
        name: 'Verify Transaction',
        component: TransactionVerify
      }
    ]
  },
  registerPage,
  passwordForgotPage,
  passwordResetPage,
  lockPage,
  logoutAction,
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 * **/
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};


export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js